<template>
  <v-row
    no-gutters
    justify="center"
    class="shop-profile"
  >
    <v-col cols="12" sm="8" md="6">
      <v-card>
        <v-card-text>
          <dl>
            <dt>住所</dt>
            <dd class="d-flex align-start">
              <div class="flex-grow-1 mr-2">
                <a :href="profile.map" target="bookin:map" class="break-all">
                  <span>〒{{profile.postal}} {{profile.address}}</span>
                </a>
                <template v-if="profile.access">
                  <br>
                  <pre class="whitespace-pre-wrap">{{profile.access}}</pre>
                </template>
              </div>
              <a
                class="d-block w-12 h-12"
                :href="profile.map" target="bookin:map"
              >
                <v-img
                  src="@/assets/map.png"
                  width="48" aspect-ratio="1"
                />
              </a>
            </dd>
            <dt>電話番号</dt>
            <dd>
              <a
                :href="`tel:${profile.phone}`"
                @click="$gtag.event('tel', {event_category: 'click'})"
              >{{profile.phone}}</a>
            </dd>
            <dt>営業時間</dt>
            <dd>{{profile.workTime}}</dd>
            <dt>定休日</dt>
            <dd>{{profile.dayOff}}</dd>
          </dl>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.shop-profile {
  h2 {
    @extend %typo-subtitle-2;
    color: $caption-black-text-color;
    line-height: 1.5rem;
    margin-bottom: .5rem;
  }

  dt {
    @extend %typo-caption;
    float: left;
    width: 5rem;
    text-align: left;
    vertical-align: top;
    line-height: 1.5rem;
    color: $caption-black-text-color;

  }

  dd {
    margin-left: 5rem;
  }

  dd::after {
    content: '';
    display: block;
    clear: left;
  }
}
</style>

<script>
import PartBase from '@/mixins/PartBase'

export default {
  name: 'ShopProfile',
  mixins: [
    PartBase
  ],
  props: {
    profile: {
      type: Object,
      required: true
    }
  }
}
</script>
